import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { fetchAccountBillabilityAction } from "../slices/accountBillabilitySlice";

export function useAccountBillability(accountIds: string[]) {
  const dispatch = useDispatch();
  const { billability, loading, error } = useSelector(
    (state: RootState) => state.accountBillability,
  );

  useEffect(() => {
    const unresolved = accountIds.filter(
      (id) => id && billability[id] === undefined,
    );
    if (unresolved.length > 0) {
      dispatch(fetchAccountBillabilityAction(unresolved));
    }
  }, [accountIds, billability, dispatch]);

  const isBillable = useCallback(
    (accountId: string): boolean | undefined => {
      const status = billability[accountId];
      if (status === undefined) return undefined;
      return status === "billable";
    },
    [billability],
  );

  const getBillabilityMessage = useCallback(
    (accountId: string): string => {
      if (billability[accountId] === "no_account") {
        return `Account ${accountId} does not exist in CARA.`;
      }
      return `Account ${accountId} has no payment method on file for Stochastic invoices.`;
    },
    [billability],
  );

  return { isBillable, getBillabilityMessage, loading, error };
}
